import { render, staticRenderFns } from "./HeaderAccountBlock.vue?vue&type=template&id=7a268210&"
import script from "./HeaderAccountBlock.vue?vue&type=script&lang=ts&"
export * from "./HeaderAccountBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderAccountBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports